import React, { useEffect, useState } from 'react';
import { api } from "../pages/api"; 

const LowStockList = () => {
  const [lowStockProducts, setLowStockProducts] = useState([]);

  useEffect(() => {
    const fetchLowStockProducts = async () => {
      try {
        const res = await api.get('/api/dash/low-stock');
        setLowStockProducts(res.data); // Assuming the API returns an array of products
      } catch (err) {
        console.error('Error fetching low-stock products:', err);
      }
    }; 

    fetchLowStockProducts();
  }, []);

  if (!lowStockProducts.length) return <p>No products are low in stock.</p>;

  return (
    <div className="card">
      <div className="card-header">
        <h5>Low Stock Products</h5>
      </div>
      <div className="card-body">
        <table className="table table-striped table-bordered">
          <thead>
            <tr>
              <th>Product Name</th>
              <th>Current Stock</th>
              <th>Minimum Stock</th>
            </tr>
          </thead>
          <tbody>
            {lowStockProducts.map((product) => (
              <tr key={product.item_id}>
                <td>{product.item_name}</td>
                <td>{product.quantity}</td>
                <td>{product.quantity}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LowStockList;
